function setPageForUserEdit({ input, state }) {
  state.set('client.currentPage', `user/edit/${input._id}`)
}

export default setPageForUserEdit



// WEBPACK FOOTER //
// ./src/modules/user/actions/setPageForUserEdit.js